//------------- REACT IMPORT ---------------//
import React, { useState } from "react";
//---------- FONTAWESOME IMPORT ------------//

//-------- BOOTSTRAP ITEMS IMPORT ----------//
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
//------------ CONSTANTS IMPORT ------------//
import * as Constants from "../../../../Helper/constants/constants";
import { Circle_Img, Filter, No_Data } from "../../../../../assets/images";
import { GirlImg } from "../../../../../assets/images";
import CustomTab from "../../../../Helper/customTabs";
import Task from "../../../Tabs/Task";
import Logs from "../../../Tabs/Logs";
import NoDataComponent from "../../../CommanComponents/NoDataComponent";


const StaffDetail = () => {
    var breadcrumData = ["Dashboard", "Manage Staff", "Staff List"];
    var breadcrumItem = "View Staff Detail";

    const [currentTab, setCurrentTab] = useState('1');
    const tabs = [
        {
            id: 1,
            tabTitle: 'Task',
        },
        {
            id: 2,
            tabTitle: 'Logs',
        },
    ];


    return (
        <div className="staff_detail_section">
            <WithoutImageHeader
                header={Constants.STAFF_DETAIL}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="staff_detail_area">
                            <div className="content_img_area">
                                <div className="left_area">
                                    <div className="img_area">
                                        <Image src={GirlImg} alt="..." />
                                    </div>
                                </div>
                                <div className="right_area">
                                    <h5>Lauren</h5>
                                    <div className="text_box">Nurse</div>
                                </div>
                            </div>
                            <div className="info_area">
                                <div className="inner_info_area">
                                    <div className="left_inner_area">
                                        <p>Joining Date</p>
                                    </div>
                                    <div className="right_inner_area">
                                        <p>21 June, 2023</p>
                                    </div>
                                </div>
                                <div className="inner_info_area">
                                    <div className="left_inner_area">
                                        <p>D.O.B</p>
                                    </div>
                                    <div className="right_inner_area">
                                        <p>5 July, 1999</p>
                                    </div>
                                </div>
                                <div className="inner_info_area">
                                    <div className="left_inner_area">
                                        <p>Specialization</p>
                                    </div>
                                    <div className="right_inner_area">
                                        <p>Virologist</p>
                                    </div>
                                </div>
                                <div className="inner_info_area">
                                    <div className="left_inner_area">
                                        <p>Department</p>
                                    </div>
                                    <div className="right_inner_area">
                                        <p>Department Name</p>
                                    </div>
                                </div>
                                <div className="inner_info_area">
                                    <div className="left_inner_area">
                                        <p>Hospital</p>
                                    </div>
                                    <div className="right_inner_area">
                                        <p>Oxford Hospital</p>
                                    </div>
                                </div>
                                <div className="inner_info_area">
                                    <div className="left_inner_area">
                                        <p>Gender</p>
                                    </div>
                                    <div className="right_inner_area">
                                        <p>Female</p>
                                    </div>
                                </div>
                                <div className="inner_info_area">
                                    <div className="left_inner_area">
                                        <p>Blood Group</p>
                                    </div>
                                    <div className="right_inner_area">
                                        <p>B+</p>
                                    </div>
                                </div>
                                <div className="inner_info_area">
                                    <div className="left_inner_area">
                                        <p>Contact Number</p>
                                    </div>
                                    <div className="right_inner_area">
                                        <p>8194745860</p>
                                    </div>
                                </div>
                                <div className="inner_info_area space">
                                    <div className="left_inner_area">
                                        <p>Address</p>
                                    </div>
                                    <div className="right_inner_area">
                                        <p>Plot no. 16, Punjab</p>
                                    </div>
                                </div>
                                <div className="circle_img">
                                    <Image src={Circle_Img} alt="..." />
                                </div>
                            </div>
                            <div className="task_btn_area">
                                <CustomTab
                                    tabs={tabs}
                                    currentTab={currentTab}
                                    setCurrentTab={(e) => setCurrentTab(e)}
                                />
                            </div>
                            <div className="tab_details">
                                <div className={parseInt(currentTab) === 1 ? 'sorting_data' : 'd-none'}>
                                    <div className="left_area">
                                        <p>Assigned Task</p>
                                    </div>
                                    <div className="right_area">
                                        <div className="sort_button">
                                            <Button className="btn-primary" type="submit"> Sort <Image src={Filter} alt="..." className="image_area" /> </Button>
                                        </div>
                                    </div>
                                </div>
                                <div className="custom_tab_data">
                                    {parseInt(currentTab) === 1 ? <Task /> : null}
                                    {parseInt(currentTab) === 2 ? <Logs /> : null}
                                </div>
                                {/* <NoDataComponent /> */}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div >
    );
};

export default StaffDetail;
